/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_dnamw_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`dsDNA is the sum of both complementary strands.`)
};

const es_dnamw_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El ADNds es la suma de ambas hebras complementarias.`)
};

const de_dnamw_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`dsDNA ist die Summe beider komplementären Stränge.`)
};

const nl_dnamw_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`dsDNA is de som van beide complementaire strengen.`)
};

const fr_dnamw_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'ADNdb est la somme des deux brins complémentaires.`)
};

const it_dnamw_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il dsDNA è la somma di entrambi i filamenti complementari.`)
};

const pt_br2_dnamw_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`dsDNA é a soma de ambas as fitas complementares.`)
};

const pt_dnamw_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O dsADN é a soma de ambas as cadeias complementares.`)
};

const ja_dnamw_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`dsDNAは両方の相補鎖の合計です。`)
};

const zh_dnamw_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`dsDNA 是两条互补链质量之和。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const dnamw_ex3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.dnamw_ex3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("dnamw_ex3", locale)
	if (locale === "en") return en_dnamw_ex3(inputs)
	if (locale === "es") return es_dnamw_ex3(inputs)
	if (locale === "de") return de_dnamw_ex3(inputs)
	if (locale === "nl") return nl_dnamw_ex3(inputs)
	if (locale === "fr") return fr_dnamw_ex3(inputs)
	if (locale === "it") return it_dnamw_ex3(inputs)
	if (locale === "pt-BR") return pt_br2_dnamw_ex3(inputs)
	if (locale === "pt") return pt_dnamw_ex3(inputs)
	if (locale === "ja") return ja_dnamw_ex3(inputs)
	return zh_dnamw_ex3(inputs)
};